export const REGULATOR_URL = process.env.REACT_APP_BASE_URL
// export const REGULATOR_URL = "https://regulator.person8.ai"